const SubAbasFluxosProaq = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/adm/fluxoproaqs/fluxoproaq/ficha/${id}/dadosgerais`,
  },
  {
    label: 'Vínculos',
    rota: `/daf/adm/fluxoproaqs/fluxoproaq/ficha/${id}/vinculos`,
  },
];

export default SubAbasFluxosProaq;
